import {ENDPOINT_URL} from '../constants/index';
const headers = new Headers();
headers.append('Content-Type', 'application/json');

export default function changeMethodCustom(testAdmin) {
	return fetch(`${ENDPOINT_URL}/changemethodemail`, {
		method: 'POST',
		mode: 'cors',
		credentials: 'include',
		headers,
		body: JSON.stringify(testAdmin),
	})
		.then((response) => {
			if (response.ok) {
				return response;
			}
			return response;

			return Promise.reject(response);
		})
		.catch((error) => {
			console.log('This seem to be the error');
		});
}
